import type { ValidateCouponRequest, ValidateCouponResponse } from '../../types/coupon';
import { delay } from '../mock/storage';

type MockCoupon = {
  code: string;
  type: 'percentage' | 'fixed';
  value: number;
  minOrderAmount: number;
  description: string;
};

const MOCK_COUPONS: MockCoupon[] = [
  {
    code: 'HOSGELDIN10',
    type: 'percentage',
    value: 10,
    minOrderAmount: 100,
    description: 'Yeni müşterilere %10 indirim',
  },
  {
    code: 'INDIRIM50',
    type: 'fixed',
    value: 50,
    minOrderAmount: 200,
    description: '200 TL üzeri siparişlerde 50 TL indirim',
  },
];

function calculateDiscount(coupon: MockCoupon, subtotal: number): number {
  const raw =
    coupon.type === 'percentage'
      ? (subtotal * coupon.value) / 100
      : coupon.value;
  return Math.round(raw * 100) / 100;
}

export async function mockValidateCoupon(
  request: ValidateCouponRequest,
): Promise<ValidateCouponResponse> {
  await delay(300);

  const code = request.code.trim().toUpperCase();
  const coupon = MOCK_COUPONS.find((c) => c.code === code);

  if (!coupon) {
    throw new Error('Geçersiz kupon kodu.');
  }

  if (request.subtotal < coupon.minOrderAmount) {
    throw new Error(
      `Bu kupon minimum ${coupon.minOrderAmount.toLocaleString('tr-TR')} TL tutarlı siparişlerde geçerlidir.`,
    );
  }

  return {
    code: coupon.code,
    discountAmount: calculateDiscount(coupon, request.subtotal),
    description: coupon.description,
  };
}
